import { FloorPlanStore } from '../../../stores/FloorPlanStore';
import { FLOOR_MAX_METER } from '../../../constants/FloorConstants';
import { MouseCoords, CropPosition } from './FloorPlanSubPage';

export class FloorPlanWizardStore {
    public angle: number = 0;
    public pixelDistance: number = 0;
    public scaleDistance: number = 0;
    public arrowPositions: Array<MouseCoords> = [];

    public cropImagePosition: MouseCoords = {x: 0, y: 0};
    public cropPosition: CropPosition = {x1: 0, x2: 100, y1: 0, y2: 100};
    public cropZoom: number = 1;

    public sizeImagePosition: MouseCoords = {x: 0, y: 0};
    public sizeZoom: number = 1;

    public getRotation(withAngle: boolean): number {
        let rotation: number = 0;
        switch (FloorPlanStore.getState().orientation) {
            case 3: rotation = 180; break;
            case 4: rotation = 180; break;
            case 5: rotation = 270; break;
            case 6: rotation = 90; break;
            case 7: rotation = 90; break;
            case 8: rotation = 270; break;
            default: break;
        }
        if (withAngle) {
            return rotation - this.getFixedAngle();
        }
        return rotation;
    }
    public getFixedAngle(): number {
        if (this.angle >= 0) {
            return Math.abs(this.angle) % 90 < 45 ? Math.abs(this.angle) % 90 : -(90 - Math.abs(this.angle) % 90);
        }
        return -(Math.abs(this.angle) % 90 < 45 ? Math.abs(this.angle) % 90 : -(90 - Math.abs(this.angle) % 90));
    }

    public setCropImagePosition(x: number, y: number): void {
        this.cropImagePosition = {x: x, y: y};
    }

    public setSizeImagePosition(x: number, y: number): void {
        this.sizeImagePosition = {x: x, y: y};
    }

    public validSize(): boolean {
        const croppedImageWidth: number = Math.abs(this.cropPosition.x1 - this.cropPosition.x2) / this.cropZoom;
        const croppedImageHeight: number = Math.abs(this.cropPosition.y1 - this.cropPosition.y2) / this.cropZoom;
        const length: number = (croppedImageWidth) / FloorPlanStore.getState().ratio;
        const depth: number = (croppedImageHeight) / FloorPlanStore.getState().ratio;
        return (length <= FLOOR_MAX_METER && depth <= FLOOR_MAX_METER);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/floorplan/FloorPlanInternalStore.ts